import { groupBy } from 'lodash'

import config from '@/config'
import characters from '@/config/characters'

const getCellKey = (x, y) => {
  return y + '-' + x
}

export default {

  // state: {},

  getters: {

    mapCharactersByCell (state, { playerLocationX, playerLocationY }) {
      return {
        [getCellKey(playerLocationX, playerLocationY)]: characters.player
      }
    },

    mapRadiosByCell (state, { radios }) {
      return groupBy(radios, (radio) => {
        return getCellKey(radio.locationX, radio.locationY)
      })
    },

    mapRadioTransmissionsByCell (state, { radioTransmissions }) {
      return groupBy(radioTransmissions, (radioTransmission) => {
        return getCellKey(radioTransmission.originX, radioTransmission.originY)
      })
    },

    mapCellsByRow (state, { mapCharactersByCell, mapRadiosByCell, mapRadioTransmissionsByCell }) {
      const cellsByRow = []

      // Make each row
      for (let y = 0; y <= config.maxMapY; y++) {
        const row = []

        // Make each cell
        for (let x = 0; x <= config.maxMapX; x++) {
          const key = getCellKey(x, y)

          // Cell content
          row.push({
            x,
            y,
            key,
            characters: mapCharactersByCell[key] || [],
            radios: mapRadiosByCell[key] || [],
            radioTransmissions: mapRadioTransmissionsByCell[key] || []
          })
        }

        cellsByRow.push(row)
      }

      return cellsByRow
    }

  }

  // mutations: {},

  // actions: {}

}
